export default __webpack_public_path__ + "static/media/trash.417c84bd.svg";